(function () {

var $5b55226219c5badd$exports = {};
$5b55226219c5badd$exports = React;


const $c53a0f08a36f035b$var$KirkiMarginPaddingForm = (props)=>{
    const { control: control, customizerSetting: customizerSetting, defaultArray: defaultArray, valueArray: valueArray, valueUnit: valueUnit } = props;
    const [inputValues, setInputValues] = (0, $5b55226219c5badd$exports.useState)(()=>{
        return valueArray;
    });
    const getSingleValueAsObject = (value)=>{
        let unit = "";
        let number = "";
        let negative = "";
        if (typeof value == "boolean") return {
            unit: '',
            number: value
        };
        if ("" !== value) {
            value = "string" !== typeof value ? value.toString() : value;
            value = value.trim();
            negative = -1 < value.indexOf("-") ? "-" : "";
            value = value.replace(negative, "");
            if ("" !== value) {
                unit = value.replace(/\d+/g, "");
                number = value.replace(unit, "");
                number = negative + number.trim();
                number = parseFloat(number);
            } else number = negative;
        }
        return {
            unit: unit,
            number: number
        };
    };
    const getValuesForInput = (values)=>{
        let singleValue;
        for(const position in values)if (Object.hasOwnProperty.call(values, position)) {
            singleValue = getSingleValueAsObject(values[position]);
            values[position] = singleValue.number;
        }
        return values;
    };
    const getValuesForCustomizer = (values)=>{
        let singleValue;
        for(const position in values)if (Object.hasOwnProperty.call(values, position)) {
            singleValue = values[position];
            if ("" !== singleValue) {
                singleValue = getSingleValueAsObject(singleValue);
                singleValue = singleValue.number;
                singleValue = typeof singleValue == "boolean" ? singleValue : singleValue + valueUnit;
            }
            values[position] = singleValue;
        }
        return values;
    };
    control.updateComponentState = (val)=>{
        setInputValues(getValuesForInput(val));
    };
    const handleChange = (e, position)=>{
        let values = {
            ...inputValues
        };
        if (values.isLinked) {
            values['top'] = e.target.value;
            values['right'] = e.target.value;
            values['bottom'] = e.target.value;
            values['left'] = e.target.value;
        } else values[position] = e.target.value;
        customizerSetting.set(getValuesForCustomizer(values));
    };
    const handleReset = (e)=>{
        const values = "" !== props.default && "undefined" !== typeof props.default ? defaultArray : valueArray;
        customizerSetting.set(getValuesForCustomizer(values));
    };
    const handleLinkClick = (e)=>{
        let values = {
            ...inputValues,
            isLinked: !inputValues.isLinked
        };
        customizerSetting.set(getValuesForCustomizer(values));
    };
    const handleKeyDown = (e, position)=>{
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
            let currentValue = parseFloat(e.target.value) || 0;
            const step = 1; // We can make this configurable if needed
            if (e.key === 'ArrowUp') currentValue += step;
            else if (e.key === 'ArrowDown') currentValue -= step;
            // Update the value
            let values = {
                ...inputValues
            };
            if (values.isLinked) {
                values['top'] = currentValue;
                values['right'] = currentValue;
                values['bottom'] = currentValue;
                values['left'] = currentValue;
            } else values[position] = currentValue;
            // Update both the state and customizer
            setInputValues(values);
            customizerSetting.set(getValuesForCustomizer(values));
        }
    };
    // Preparing for the template.
    const fieldId = `kirki-control-input-${props.type}-top`;
    const unitRef = (0, $5b55226219c5badd$exports.useRef)(null);
    const makeMapable = ()=>{
        const items = [];
        for(const position in inputValues){
            if (Object.hasOwnProperty.call(inputValues, position)) {
                if (typeof inputValues[position] != "boolean") items.push({
                    position: position,
                    value: inputValues[position]
                });
            }
        }
        return items;
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-form dashicons-picker",
        tabIndex: "1"
    }, (props.label || props.description) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("label", {
        className: "kirki-control-label",
        htmlFor: fieldId
    }, props.label && /*#__PURE__*/ React.createElement("span", {
        className: "customize-control-title"
    }, props.label), props.description && /*#__PURE__*/ React.createElement("span", {
        className: "customize-control-description description",
        dangerouslySetInnerHTML: {
            __html: props.description
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: "customize-control-notifications-container",
        ref: props.setNotificationContainer
    })), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "kirki-control-reset",
        onClick: handleReset
    }, /*#__PURE__*/ React.createElement("i", {
        className: "dashicons dashicons-image-rotate"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-cols"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-left-col"
    }, /*#__PURE__*/ React.createElement("div", {
        class: "kirki-control-fields"
    }, makeMapable(inputValues).map((item)=>{
        const className = `kirki-control-input kirki-control-input-${item.position}`;
        const id = `kirki-control-input-${props.type}-${item.position}`;
        return /*#__PURE__*/ React.createElement("div", {
            class: "kirki-control-field"
        }, /*#__PURE__*/ React.createElement("input", {
            id: id,
            type: "text",
            value: item.value || 0 === item.value ? item.value : "",
            className: className,
            onChange: (e)=>handleChange(e, item.position),
            onKeyDown: (e)=>handleKeyDown(e, item.position)
        }), /*#__PURE__*/ React.createElement("label", {
            class: "kirki-control-sublabel",
            htmlFor: id
        }, item.position));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-right-col"
    }, /*#__PURE__*/ React.createElement("span", {
        className: `newsx-spacing-linked ${inputValues.isLinked ? 'active' : ''}`,
        onClick: handleLinkClick
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 5C10.3431 5 9 6.34315 9 8V10H7V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H15V8C15 6.34315 13.6569 5 12 5Z",
        fill: "#0284c7"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 19C10.3431 19 9 17.6569 9 16V14H7V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V14H15V16C15 17.6569 13.6569 19 12 19Z",
        fill: "#0284c7"
    }), /*#__PURE__*/ React.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11 16V8H13V16H11Z",
        fill: "#0284c7"
    }))))));
};
var $c53a0f08a36f035b$export$2e2bcd8739ae039 = $c53a0f08a36f035b$var$KirkiMarginPaddingForm;


function $7d8bd30ed53bd9e9$var$_extends() {
    return $7d8bd30ed53bd9e9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d8bd30ed53bd9e9$var$_extends.apply(null, arguments);
}
/**
 * KirkiMarginPaddingControl.
 *
 * Global objects brought:
 * - wp
 * - jQuery
 * - React
 * - ReactDOM
 *
 * @class
 * @augments wp.customize.Control
 * @augments wp.customize.Class
 */ const $7d8bd30ed53bd9e9$var$KirkiMarginPaddingControl = wp.customize.Control.extend({
    /**
   * Initialize.
   *
   * @param {string} id - Control ID.
   * @param {object} params - Control params.
   */ initialize: function(id, params) {
        const control = this;
        // Bind functions to this control context for passing as React props.
        control.setNotificationContainer = control.setNotificationContainer.bind(control);
        wp.customize.Control.prototype.initialize.call(control, id, params);
        // The following should be eliminated with <https://core.trac.wordpress.org/ticket/31334>.
        function onRemoved(removedControl) {
            if (control === removedControl) {
                control.destroy();
                control.container.remove();
                wp.customize.control.unbind("removed", onRemoved);
            }
        }
        wp.customize.control.bind("removed", onRemoved);
    },
    /**
   * Set notification container and render.
   *
   * This is called when the React component is mounted.
   *
   * @param {Element} element - Notification container.
   * @returns {void}
   */ setNotificationContainer: function setNotificationContainer(element) {
        const control = this;
        control.notifications.container = jQuery(element);
        control.notifications.render();
    },
    /**
   * Render the control into the DOM.
   *
   * This is called from the Control#embed() method in the parent class.
   *
   * @returns {void}
   */ renderContent: function renderContent() {
        const control = this;
        ReactDOM.render(/*#__PURE__*/ React.createElement((0, $c53a0f08a36f035b$export$2e2bcd8739ae039), $7d8bd30ed53bd9e9$var$_extends({}, control.params, {
            control: control,
            customizerSetting: control.setting,
            setNotificationContainer: control.setNotificationCotainer,
            value: control.params.value
        })), control.container[0]);
        if (false !== control.params.choices.allowCollapse) control.container.addClass("allowCollapse");
    },
    /**
   * After control has been first rendered, start re-rendering when setting changes.
   *
   * React is able to be used here instead of the wp.customize.Element abstraction.
   *
   * @returns {void}
   */ ready: function ready() {
        const control = this;
        /**
     * Update component value's state when customizer setting's value is changed.
     */ control.setting.bind((val)=>{
            control.updateComponentState(val);
        });
    },
    /**
   * This method will be overriden by the rendered component.
   */ updateComponentState: (val)=>{},
    /**
   * Handle removal/de-registration of the control.
   *
   * This is essentially the inverse of the Control#embed() method.
   *
   * @link https://core.trac.wordpress.org/ticket/31334
   * @returns {void}
   */ destroy: function destroy() {
        const control = this;
        // Garbage collection: undo mounting that was done in the embed/renderContent method.
        ReactDOM.unmountComponentAtNode(control.container[0]);
        // Call destroy method in parent if it exists (as of #31334).
        if (wp.customize.Control.prototype.destroy) wp.customize.Control.prototype.destroy.call(control);
    }
});
var $7d8bd30ed53bd9e9$export$2e2bcd8739ae039 = $7d8bd30ed53bd9e9$var$KirkiMarginPaddingControl;


// Register control type with Customizer.
wp.customize.controlConstructor["kirki-margin"] = (0, $7d8bd30ed53bd9e9$export$2e2bcd8739ae039);
wp.customize.controlConstructor["kirki-padding"] = (0, $7d8bd30ed53bd9e9$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=control.js.map
